// top.js
import React from 'react';
import { NavLink } from "react-router-dom";
import { Nav,  Icon} from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css'

class HeaderMenu extends React.Component 
{
	constructor(props)
    {
		super();
	
		let active = null;

		if( props.titleNode!==undefined )
		{
			active = props.titleNode[0].name;

			for(var i in props.titleNode)
			{
				if(props.titleNode[i].exact === true )
				{
					active = props.titleNode[i].name;
				}
			}
		}

		this.state = {
			active: active,
			titleNode : props.titleNode
		};

		this.handleSelect = this.handleSelect.bind(this);

		props.onSelect(active);
	}

	handleSelect( activeKey ) 
	{
		this.props.onSelect(activeKey);

		this.setState({ active: activeKey });
	}

	render() 
	{
		let { active, titleNode} = this.state;

		const { activeKey } = this.props;
		
		if( activeKey!==undefined )
		{
			active = activeKey;
		}

		return (
			<div className="system-menu">
				<Nav>
				{
					titleNode.map((item, index) => {

						let pathname = item.path!==undefined ? item.path : "#";

						let icon = undefined 
						
						if( item.properties!==undefined && item.properties.icon!==undefined )
						{
							icon = item.properties.icon;
						}

						if( item.type==="LINK" )
						{
							if( active===item.name ) 
							{
								return <Li key={index} className="rs-nav-item rs-nav-item-active">
									<NavLink to={{pathname:pathname, state:{id:item.id, node:item}}}>
										<Icon icon={icon} />
										{item.title}
									</NavLink>
								</Li>
							}
							else
							{
								return <Li key={index} className="rs-nav-item">
									<NavLink to={{pathname:pathname, state:{id:item.id, node:item}}} >
										<Icon icon={icon} />
										{item.title}
									</NavLink>
								</Li>
							}
						}
						else
						{
							if(icon!==undefined )
							{
								if( active===item.name ) 
								{
									return <Li key={index} className="rs-nav-item rs-nav-item-active">
										<NavLink to={{pathname:pathname, state:{children:item.subcomponents, node:item}}}>
											<Icon icon={icon} />
											{item.title}
										</NavLink>
									</Li>
								}
								else
								{
									return <Li key={index} className="rs-nav-item">
										<NavLink to={{pathname:pathname, state:{children:item.subcomponents, node:item}}} >
											<Icon icon={icon} />
											{item.title}
										</NavLink>
									</Li>
								}
							}
							else
							{
								if( active===item.name ) 
								{
									return <Li key={index} className="rs-nav-item rs-nav-item-active">
										<NavLink to={{pathname:pathname, state:{children:item.subcomponents, node:item}}} >
											{item.title}
										</NavLink>
									</Li>
								}
								else
								{
									return <Li key={index} className="rs-nav-item">
										<NavLink to={{pathname:pathname, state:{children:item.subcomponents, node:item}}} >
											{item.title}
										</NavLink>
									</Li>
								}
							}
						}
					})
				}
				</Nav>
			</div>
		);
	}      
}

const Li = ({hasTooltip, children, ...rest}) => (
    <li {...rest}>{children}</li>
)

export default HeaderMenu